/**
 * Datums in de taal van de app en niet in die van de browser. Los punt 21 oktober
 * 2026: Abonnement en Winkel riepen `toLocaleDateString()` zonder taal aan, dus een
 * NL-app in een Engelse browser toonde een Engelse datum.
 *
 * PUUR: de taal komt van de aanroeper (`useTaal`).
 */

const LOCALE = { nl: "nl-NL", en: "en-GB" };

/** De locale die bij de taal van de app hoort; onbekend wordt Nederlands. */
export function localeVan(taal) {
  return LOCALE[taal] || LOCALE.nl;
}

/** Een moment in seconden sinds 1970 als dag, in de taal van de app en de zone van de lezer. */
export function dagVanSeconden(seconden, taal) {
  return new Date(seconden * 1000).toLocaleDateString(localeVan(taal));
}

/** Een ISO-moment als dag, in de taal van de app; onleesbaar wordt leeg. Punt 5 (22 okt 2026). */
export function dagVanIso(iso, taal) {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString(localeVan(taal));
}

/**
 * Hoe lang geleden, in woorden en in de taal van de app. Punt 5 (22 okt 2026): dit
 * stond in `FolderSyncStatus` met vaste Nederlandse woorden en een datum in de taal
 * van de browser.
 *
 * De backend levert naieve UTC, dus er gaat een `Z` achter voordat de browser hem
 * leest; zonder die `Z` staat er in de zomer "2 uur geleden" bij een ronde van zojuist.
 */
export function geledenTekst(iso, t, taal, nu = Date.now()) {
  if (!iso) return null;
  const toen = new Date(iso.endsWith("Z") ? iso : `${iso}Z`);
  const seconden = Math.round((nu - toen.getTime()) / 1000);
  if (Number.isNaN(seconden)) return null;
  if (seconden < 90) return t("zojuist");
  if (seconden < 3600) return t("{n} min geleden", { n: Math.round(seconden / 60) });
  if (seconden < 86400) return t("{n} uur geleden", { n: Math.round(seconden / 3600) });
  return toen.toLocaleDateString(localeVan(taal));
}
